import React from 'react';
import _ from 'underscore';

const UnitTemplateProfileStandards = ({ data, }) => {
  const standards = _.uniq(data.activities.map(act => act.standard && act.standard.name)).filter(Boolean)
  const concepts = _.uniq(data.activities.map(act => act.standard && act.standard.standard_category && act.standard.standard_category.name)).filter(Boolean)
  const productionActivitiesRecommendedBy = data.diagnostics_recommended_by.filter(act => act.flags.includes("production") && act.name.length)

  if (!data.time && !standards.length && !concepts.length && !productionActivitiesRecommendedBy.length) { return null}

  const renderStandards = () => {
    if (!standards.length) { return null }

    return (
      <div>
        <dt><strong>Standards</strong></dt>
        {standards.map(s => <dd key={s}>{s}</dd>)}
      </div>
    )
  };

  const renderConcepts = () => {
    if (!concepts.length) { return null }

    return (
      <div>
        <dt><strong>Concepts</strong></dt>
        <div className="concepts">{concepts.map(s => <dd className="concept" key={s}>{s}</dd>)}</div>
      </div>
    )
  };

  const renderRecommendedBy = () => {
    if (productionActivitiesRecommendedBy.length === 0) { return null }

    return (
      <div>
        <dt><strong>Recommended by</strong></dt>
        {productionActivitiesRecommendedBy.map(s => <dd key={s}>{s.name}</dd>)}
      </div>
    )
  };


  return (
    <div className="standards-and-concepts light-gray-bordered-box">
      {data.time && (
        <header className="metadata-card-header">
          <strong>Estimated Time:</strong>
          <span>{data.time} mins</span>
        </header>
      )}
      <div className="metadata-card-body">
        <dl>
          {renderStandards()}
          {renderConcepts()}
          {renderRecommendedBy()}
        </dl>
      </div>
    </div>
  );
}

export default UnitTemplateProfileStandards
